import { useEffect, useLayoutEffect, useState } from "react";

import { t } from "@lingui/macro";
import Image from "next/image";
import styled, { useTheme } from "styled-components";

import FeedBackForm from "components/feedback/form";
import { useTrackerContext } from "context/tracker";
import { TaskState } from "types/types";
import { formatDateTime } from "utils/datetime-utils";

const Container = styled.div<{ showForm: string }>`
  display: flex;
  align-items: center;
  width: 100%;
  flex-direction: column;
  justify-content: center;
  height: 90vh;
  color: #ffffff;

  @media only screen and (max-width: 768px) {
    height: max-content;
    position: fixed;
    bottom: ${(props) => (props.showForm == "true" ? "0px" : "50%")};
  }
`;

const Status = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin: 24px 0;

  span {
    text-align: center;
    margin-top: 16px;
  }
`;

export const useTranslations = () => {
  const translatedStatus: { [key: string]: string } = {
    completed: t`completed`,
    assigned: t`assigned`,
    failed: t`failed`,
    accepted: t`accepted`,
    transit: t`transit`,
    active: t`active`,
    cancelled: t`cancelled`,
    unassigned: t`unassigned`,
  };

  const translatedCategory: { [key: string]: string } = {
    drop_off: t`Drop off`,
    pick_up: t`Pick up`,
    assignment: t`Assignment`,
  };

  return { translatedStatus, translatedCategory };
};

const Feedback = () => {
  const [showStatus, setShowStatus] = useState(true);
  const [showFeedbackForm, setShowFeedbackForm] = useState<boolean | undefined>(false);

  const { data: tracker, trackerID } = useTrackerContext();
  const { icons, text }: any = useTheme();

  const { translatedStatus } = useTranslations();

  const status = tracker?.tasks[tracker?.tasks.length - 1]?.state;
  const timestamp =
    tracker?.tasks[tracker?.tasks.length - 1].failed_at ||
    tracker?.tasks[tracker?.tasks.length - 1].cancelled_at ||
    tracker?.tasks[tracker?.tasks.length - 1].completed_at ||
    "";
  // if tracker is inactive, and At least one of the tasks is completed
  const isOneTaskCompleted = tracker?.tasks.some((task) => task.state === TaskState.COMPLETED);

  useEffect(() => {
    setShowFeedbackForm(isOneTaskCompleted && tracker?.reviews_allowed && !tracker?.reviewed_at);
  }, [isOneTaskCompleted, tracker?.reviewed_at, tracker?.reviews_allowed]);

  useLayoutEffect(() => {
    // Hide delivery status when height of screen is too small
    window.addEventListener("resize", (e) => {
      if (window.innerHeight < 667) {
        setShowStatus(false);
      } else {
        setShowStatus(true);
      }
    });
  }, [showStatus]);

  return (
    <Container showForm={`${showFeedbackForm}`}>
      {showStatus && (
        <Status>
          {getIcon(status, icons)}
          <span>
            {text.feedback} {translatedStatus[status as string]}
            {timestamp && " " + t`at`} <br />
            <b>{timestamp && formatDateTime(timestamp)}</b>
          </span>
        </Status>
      )}
      <FeedBackForm trackerId={trackerID} show={showFeedbackForm} onChangeVisibility={setShowFeedbackForm} />
    </Container>
  );
};

const getIcon = (status: string | undefined, icons: any) => {
  switch (status) {
    case "completed":
      return <Image src={icons.success} alt={"contact"} width={80} height={80} />;
    default:
      return <Image src={icons.failed} alt={"contact"} width={80} height={80} />;
  }
};

export default Feedback;
